import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';
import { Loader2 } from 'lucide-react';

type UserRole = 'SUPERADMIN' | 'ADMIN' | 'OWNER' | 'PARTNER';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAuthStore();

  // Show loading while checking auth state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <Loader2 className="w-10 h-10 text-cyan-600 animate-spin mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">Betoltes...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Check role-based access
  if (allowedRoles && user && !allowedRoles.includes(user.role as UserRole)) {
    // Redirect non-admin users trying to access admin pages to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
